import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FboBusinessService } from 'src/app/business/fbo/fbo-business.service';
import { ManageConfirmationComponent } from 'src/app/shared/components/manage-confirmation/manage-confirmation.component';
import { NotificationComponent } from 'src/app/shared/components/notification/notification.component';
import { SharedService } from '../../../layouts/shared-service';
import { AppDialogWrapperService } from '../../../ni-components/app-dialog-wrapper/app-dialog-wrapper.service';

@Component({
    selector: 'app-group-fbos-grid',
    templateUrl: './group-fbos-grid.component.html',
    styleUrls: ['./group-fbos-grid.component.scss'],
})
export class GroupFbosGridComponent implements OnInit {
    @Input() dataSource: any;
    @Input() isNetworkFbo: boolean;    

    displayedColumns = [
        'icao',
        'fbo',
        'pricingExpired',
        'needAttentionCustomers',
        'lastLogin',
        'users',
        'quotes30Days',
        'orders30Days',
        'accountExpired',
        'accountType',
        'actions',
    ];

    searchValue = '';
    tableLocalStorageFilterKey = 'conductor-group-grid-filter';

    constructor(
        private router: Router,
        private fboBusinessService: FboBusinessService,
        private sharedService: SharedService,
        private appDialogWrapperService: AppDialogWrapperService
    ) {}

    ngOnInit()
    {
        
        
    }

    editFBO(fbo: any) {
        this.router.navigate(['/default-layout/fbos/' + fbo.oid]);
    }
    manageFBO(fbo: any) {
        if (!fbo.active) {
            const dialogWrapper = this.appDialogWrapperService.open({
                title: 'Inactive fbo',
                component: NotificationComponent,
                width: '450px',
                data: {
                    text: "You can't manage an inactive fbo!",
                    title: 'Inactive fbo',
                },
            });
        } else {
            const dialogWrapper = this.appDialogWrapperService.open({
                title: 'Manage FBO?',
                component: ManageConfirmationComponent,
                width: '450px',
                hideHeader: true,
                data: {
                    description:
                        'This will temporarily switch your account to a primary user for this FBO.  Would you like to continue?',
                    fboId: fbo.oid,
                    title: 'Manage FBO?',
                },
            });

            dialogWrapper.afterClosed().subscribe(async (result) => {
                if (!result) {
                    return;
                }

                localStorage.setItem(
                    this.tableLocalStorageFilterKey,
                    this.searchValue
                );
                this.fboBusinessService.logIntoFboAccount(fbo, this.isNetworkFbo, this.sharedService.isConductorUser);
            });
        }
    }
}
